// Module
var code = "<div class=\"spinner\"> <img class=\"layer spinner-outer\" src=\"/vectors/spinner-outer.svg\"/> <img class=\"layer spinner-inner\" src=\"/vectors/spinner-inner.svg\"/> </div> ";
// Exports
module.exports = code;